/**
 * Click ID Extension for Chekly CheckoutManager
 *
 * Captures the `click_id` URL parameter when a visitor lands on the store,
 * stores it in a cookie for persistence across page navigations,
 * and appends it to the checkout redirect URL.
 */

(function () {
  'use strict';

  const COOKIE_NAME = 'chekly_click_id';
  const COOKIE_LIFETIME_DAYS = 30;
  const PARAM_NAME = 'click_id';

  function getCookie(name) {
    const escaped = name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1');
    const match = document.cookie.match(new RegExp(`(?:^|; )${escaped}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/;`;
  }

  function captureClickId() {
    const params = new URLSearchParams(window.location.search);
    const clickId = params.get(PARAM_NAME);
    if (clickId) {
      setCookie(COOKIE_NAME, clickId, COOKIE_LIFETIME_DAYS);
      return clickId;
    }
    return getCookie(COOKIE_NAME);
  }

  function setupExtension() {
    if (typeof window === 'undefined' || !window.checkoutManager) {
      return false;
    }

    if (typeof window.checkoutManager.on !== 'function') {
      return false;
    }

    if (window.checkoutManager._clickIdExtensionApplied) {
      return true;
    }

    window.checkoutManager.on('beforeUrlBuild', (url) => {
      const clickId = getCookie(COOKIE_NAME);
      if (!clickId) return url;
      const separator = url.includes('?') ? '&' : '?';
      return `${url}${separator}${PARAM_NAME}=${encodeURIComponent(clickId)}`;
    });

    window.checkoutManager._clickIdExtensionApplied = true;
    return true;
  }

  // Capture click_id from URL immediately on page load
  captureClickId();

  // Hook into checkoutManager once available
  if (!setupExtension()) {
    const interval = setInterval(() => {
      if (setupExtension()) {
        clearInterval(interval);
      }
    }, 100);

    window.addEventListener('load', () => {
      setupExtension();
      clearInterval(interval);
    });
  }
})();